var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.screenType === 'desktop')?_c('about-us-desktop'):_c('about-us-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }